import { ROUTE_PATH } from './consts';

export const createKkmPageUrl = kkmId =>
  `${ROUTE_PATH.replace(':kkmId', kkmId)}`;
